import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';

import DrawerHeader from 'components/Navigate/Drawers/RightHeader';

import {rightDrawerWidth} from 'styles/contants';
import * as I from 'interfaces';

import {useInputMenuContext} from 'context/InputMenu';
import {rightDrawerMenuHandler} from 'components/InputMenu/helpers';
import Drawer from '@mui/material/Drawer';
import {useTranslation} from 'react-i18next';
import {Stack, useTheme} from '@mui/material';
import {useCallback, useEffect, useRef, useState} from 'react';
import {RIGHT_DRAWER_ZINDEX_DIFF} from 'appConstants';
import {useFlags} from 'launchdarkly-react-client-sdk';

export const AUTO_FOCUS_CLASS = 'right-drawer-auto-focus';
const ANIMATION_DURATION = 200;

export function RightDrawer() {
  const {t} = useTranslation('common');
  const [display, setDisplay] = useState(false);
  const componentWrapperRef = useRef<HTMLDivElement | null>(null);

  const inputContext = useInputMenuContext();
  const inputMenuState = inputContext?.state;
  const inputMenuDispatch = inputContext?.dispatch;

  const method = inputMenuState?.method;
  const form = inputMenuState?.form;
  const persistent = inputMenuState?.persistent;
  const flags = useFlags();
  const selectedForm = form && method && rightDrawerMenuHandler(form, method, t, flags);
  const theme = useTheme();

  const closeDrawer = useCallback(() => {
    inputMenuDispatch && inputMenuDispatch({type: I.inputMenuActionType.closeMenu});
    inputMenuState?.onClose && inputMenuState.onClose();
  }, [inputMenuDispatch, inputMenuState]);

  useEffect(() => {
    if (persistent) {
      const escapeButtonHandler = (event: KeyboardEvent) => {
        if (event.key === 'Escape') {
          closeDrawer();
        }
      };
      window.addEventListener('keydown', escapeButtonHandler);

      return () => {
        window.removeEventListener('keydown', escapeButtonHandler);
      };
    }
  }, [closeDrawer, persistent]);

  useEffect(() => {
    if (!selectedForm) {
      setDisplay(false);
    }
    if (selectedForm) {
      setTimeout(() => {
        setDisplay(true);
        const inputField = componentWrapperRef.current?.querySelector<HTMLInputElement>(`.${AUTO_FOCUS_CLASS} input`);
        inputField?.focus();
        inputField?.select();
      }, ANIMATION_DURATION);
    }
  }, [selectedForm]);

  return (
    <Drawer
      anchor="right"
      open={selectedForm !== undefined}
      onClose={closeDrawer}
      sx={{zIndex: theme.zIndex.drawer + RIGHT_DRAWER_ZINDEX_DIFF}}
      ModalProps={{
        BackdropProps: {
          sx: {
            background: 'transparent',
          },
        },
      }}
      elevation={0}
      variant={persistent ? 'persistent' : 'temporary'}
      transitionDuration={ANIMATION_DURATION / 1000}
    >
      <Stack
        direction="column"
        style={{
          height: '100%',
          width: rightDrawerWidth,
          borderLeft: `1px solid ${theme.palette.divider}`,
        }}
      >
        {selectedForm && <DrawerHeader title={selectedForm.title} closeDrawer={closeDrawer} />}
        <Divider />
        <Box display="flex">
          <Box flexGrow={1}>
            <Box ref={componentWrapperRef} display={display ? 'flex' : 'none'} justifyContent="center" m={2} mb={0}>
              {selectedForm?.component && selectedForm.component()}
            </Box>
          </Box>
        </Box>
      </Stack>
    </Drawer>
  );
}
